// Who a guest is, for a screen — the same reading as the backend's utils/guestIdentity:
// a PMS room sign-in that got no name is "Guest Room 302", and a guest with no mobile
// has a stand-in ("guest-<branch>-…") so the unique index holds. Neither is the person;
// the room is shown instead.
const PLACEHOLDER_NAME = /^Guest Room\s+(\S+)$/i;
const SYNTHETIC_MOBILE = /^(guest|asr)-/i;

/**
 * @returns {{ name, mobile, roomNumber, userType, label }|null} — label is what to show:
 *          the name, else "Room 302", else the mobile; null when there is nothing.
 */
export function guestIdentity(user) {
    if (!user) return null;
    const rawName = String(user.name || '').trim();
    const placeholder = rawName.match(PLACEHOLDER_NAME);
    const name = rawName && !placeholder ? rawName : null;
    const mobile = user.mobile && !SYNTHETIC_MOBILE.test(String(user.mobile)) ? user.mobile : null;
    const roomNumber = user.roomNumber || (placeholder ? placeholder[1] : null);
    return {
        name,
        mobile,
        roomNumber,
        userType: user.userType || null,
        label: name || (roomNumber ? `Room ${roomNumber}` : null) || mobile || null,
    };
}

export const guestLabel = (user, fallback = 'Unknown') => guestIdentity(user)?.label || fallback;

// The line under the label: the room (when a name is shown above it) and the mobile
// (unless the mobile is the label itself).
export const guestDetails = (user) => {
    const g = guestIdentity(user);
    if (!g) return [];
    return [g.name && g.roomNumber && `Room ${g.roomNumber}`, g.mobile !== g.label && g.mobile].filter(Boolean);
};
